import { Box, Typography, Stack } from "@mui/material";
import { WaydValueMetricBoxProps } from "./types";
import { grey } from "@mui/material/colors";

export default function WaydValueMetricBox({
  value,
  label,
  color = "text.primary",
}: WaydValueMetricBoxProps) {
  return (
    <Box
      sx={{
        bgcolor: grey[200],
        borderRadius: 2,
        p: 2,
        width: 130,
      }}
    >
      <Stack alignItems="center">
        <Typography variant="h5" color={color}>
          {value}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Stack>
    </Box>
  );
}
